import { createContext, useContext } from "react";

export const FixedActionButtonsContext = createContext(null);

const { Provider, Consumer } = FixedActionButtonsContext;

export const useFixedActionButtons = () => {
  return useContext(FixedActionButtonsContext);
};

export { Provider, Consumer };
